import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import Card from "../../../Card";
import Table from "../../../Table";
import Dashboard from "../../../../Utility/Crud/Dashboard";
import DashboardWidget from "../../../../Utility/Crud/DashboardWidget";
import MainContext from "../../../../Context/MainContext/MainContext";

export default function CardAdminDashboardList() {
  const context = useContext(MainContext);
  const history = useHistory();

  const renderContent = () => {
    const dashboards = Dashboard.sort(Object.values(context.dashboardsIndexed));
    const rows = dashboards.map((dashboard) => {
      const dashboardWidgets = Object.values(context.dashboardWidgetsIndexed)
        .filter(
          (dashboardWidget) => dashboardWidget.dashboardId === dashboard.id,
        )
        .sort((a, b) => a.ordinal - b.ordinal);
      const dashboardWidgetsCsv = dashboardWidgets
        .map((dashboardWidget) =>
          DashboardWidget.getDisplayName(dashboardWidget),
        )
        .join(", ");

      return {
        ...dashboard,
        dashboardWidgets: dashboardWidgetsCsv,
      };
    });

    return (
      <Table
        search={true}
        columns={[
          { key: "id", name: "ID", type: "number" },
          { key: "name", name: "Name", type: "string", width: 260 },
          { key: "dashboardWidgets", name: "Widgets", type: "string" },
        ]}
        rows={rows}
        onClick={(dashboard) => {
          history.push(`/admin/dashboard/${dashboard.id}`);
        }}
      />
    );
  };

  return <Card renderContent={renderContent} getTitle={() => null} />;
}
